import React from "react";
import { Link, useParams } from "react-router-dom";
import { productGroups } from "../../mock";
import { useLanguage } from "../../contexts/LanguageContext";

const CategorySidebar = () => {
    const { slug, subSlug } = useParams();
    const { lang } = useLanguage();

    return (
        <div className="w-full lg:w-[300px] flex-shrink-0">
            <div className="flex flex-col space-y-2">
                {productGroups.map((group) => {
                    const isActive = slug === group.slug;
                    const hasSubCategories = group.subCategories && group.subCategories.length > 0;
                    
                    return (
                        <div key={group.id} className="flex flex-col space-y-1">
                            <Link
                                to={isActive ? "/products" : `/products/${group.slug}`}
                                className={`px-6 py-3 rounded-full text-xs font-bold tracking-widest uppercase transition-all duration-300 ${isActive
                                        ? "bg-primary text-white shadow-md transform translate-x-2"
                                        : "bg-gray-100 text-gray-700 hover:bg-gray-200"
                                    }`}
                            >
                                {group[`title_${lang}`]}
                            </Link>
                            
                            {isActive && hasSubCategories && (
                                <div className="pl-8 flex flex-col space-y-1 mt-1 mb-2 border-l-2 border-primary/20 ml-4">
                                    {group.subCategories.map((sub) => {
                                        const isSubActive = subSlug === sub.slug;
                                        return (
                                            <Link
                                                key={sub.slug}
                                                to={isSubActive ? `/products/${group.slug}` : `/products/${group.slug}/${sub.slug}`}
                                                className={`py-2 text-[10px] font-bold tracking-wider uppercase transition-colors hover:text-primary ${isSubActive ? "text-primary" : "text-gray-500"}`}
                                            >
                                                {sub[`title_${lang}`]}
                                            </Link>
                                        );
                                    })}
                                </div>
                            )}
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default CategorySidebar;
